import { render, staticRenderFns } from "./PageEducatorClassroomStudentEdit.vue?vue&type=template&id=3e937966&scoped=true&"
import script from "./PageEducatorClassroomStudentEdit.vue?vue&type=script&lang=js&"
export * from "./PageEducatorClassroomStudentEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorClassroomStudentEdit.vue?vue&type=style&index=0&id=3e937966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e937966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VRow})
